<template>
  <div class="basicInfo tableBox">
    <span class="tip">作业详情</span>
    <noFound v-if="workList"></noFound>
    <table v-else>
      <tr>
        <th class="fixTitle">排名</th>
        <th class="fixTitle">姓名</th>
        <th class="fixTitle">完成情况</th>
        <th class="fixTitle">总分 </th>
      </tr>
      <tr v-for="(item, i) in userList.slice(0,10)">
        <td>{{i + 1}}</td>
        <td>{{item.userName}}</td>
        <td>{{item.finishCount}} / {{item.totalWork}}</td>
        <td>{{item.totalScore}}</td>
      </tr>
      <tr>
        <td>
          <a class="loadMore" :href="url">点击查看更多作业详情>></a>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import noFound from "./../noData/nodata.vue";
export default {
  props: ['userList', 'workList', 'url'],
  data() {
    return {
    };
  },
  components: {
    noFound
  },
  created() {
    this.$nextTick(() => {
      // this.getList()
    })
  },
  methods: {
    getList () {
      let list = this.userList
      if (list.length > 10) {
        this.userList = list.slice(0,10)
      }
    },
    setSorcTable () { 
      let data = [
        {
          sentData: '2018-07-28',
          contentlist: [
            {
              workName: 'one',
              className: '一班',
              submitAvg: '50%',
              excellentAvg: '15%',
              passAvg: '75%',
              unPassAvg: '25%'
            },
            {
              workName: 'one',
              className: '2班',
              submitAvg: '40%',
              excellentAvg: '15%',
              passAvg: '65%',
              unPassAvg: '35%'
            },
            {
              workName: 'one',
              className: '3班',
              submitAvg: '50%',
              excellentAvg: '15%',
              passAvg: '60%',
              unPassAvg: '40%'
            }
          ]
        },
        {
          sentData: '2018-07-28',
          contentlist: [
            {
              workName: 'one',
              className: '一班',
              submitAvg: '50%',
              excellentAvg: '15%',
              passAvg: '75%',
              unPassAvg: '25%'
            },
            {
              workName: 'one',
              className: '2班',
              submitAvg: '40%',
              excellentAvg: '15%',
              passAvg: '65%',
              unPassAvg: '35%'
            },
            {
              workName: 'one',
              className: '3班',
              submitAvg: '50%',
              excellentAvg: '15%',
              passAvg: '60%',
              unPassAvg: '40%'
            }
          ]
        },
        {
          sentData: '2018-07-28',
          contentlist: [
            {
              workName: 'one',
              className: '一班',
              submitAvg: '50%',
              excellentAvg: '15%',
              passAvg: '75%',
              unPassAvg: '25%'
            },
            {
              workName: 'one',
              className: '2班',
              submitAvg: '40%',
              excellentAvg: '15%',
              passAvg: '65%',
              unPassAvg: '35%'
            },
            {
              workName: 'one',
              className: '3班',
              submitAvg: '50%',
              excellentAvg: '15%',
              passAvg: '60%',
              unPassAvg: '40%'
            }
          ]
        }
      ]
    }
  }
};
</script>



// WEBPACK FOOTER //
// reportTable.vue?05660d98